import React from "react";
import { injectIntl } from 'react-intl';
import AssetDetailsDropdown from "./asset-details-dropdown";
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { toggleVolume, displayDropdown, removeDropdown, updateWatchlist, newActiveVideo, setSelectedAsset, setSelectedAssetRow } from '../../redux/actions/SVOD';
import VideoPlayer from './video-player';
import SVODStatus from '../../analytics/analytics-events/SVODStatus';
import { SVODStatusEvent } from '../../analytics/analytics-events/constants';
import { EnvType } from "./constants";
import svodMessages from '../../locales/svod';

class BillboardItem extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			active: true,
			imageLoaded: false,
		};
		
		this.backgroundFadeInterval = {};
		this.video = this.props.video;
		this.upVolume = this.upVolume.bind(this);
		this.downVolume = this.downVolume.bind(this);
		this.handleOpen = this.handleOpen.bind(this);
		this.videoEnded = this.videoEnded.bind(this);
		this.restartVideo = this.restartVideo.bind(this);
		this.triggerReport = this.triggerReport.bind(this);
		this.updateWatchlist = this.updateWatchlist.bind(this);
		this.selectAsset = this.selectAsset.bind(this);
	}

	handleOpen(e) {
		this.props.eventHandler({ data: { event_type: "opened_billboard_details", type: "billboard", action: "opened_billboard_details", asset_id: this.video._id.valueOf(), time: Date.now()}});
		
		let payload = {
			video: this.video,
			label: "Splash" 
		};

		this.props.newActiveVideo("dropdown");
		this.props.displayDropdown(payload);    
	}

	componentDidMount() {
		this.props.newActiveVideo("billboard");

		this.backgroundFadeInterval = setInterval(() => {
			if (!this.state.imageLoaded) {
				let img = document.getElementById(`${this.props.label}-${this.video._id.valueOf()}-img`);
				if (img && img.complete) {
					img.style.opacity = 1;
					this.setState({ imageLoaded: true });
				}
			}
		}, 500);
	}

	componentDidUpdate(prevProps, prevState) {
		if (!prevState.imageLoaded && this.state.imageLoaded) {
			clearInterval(this.backgroundFadeInterval);
		}
	}

	componentWillUnmount() {
		if (this.backgroundFadeInterval) {
			clearInterval(this.backgroundFadeInterval);
		}
	}

	triggerReport () {
		let videoItem = this.video;
		if (this.props.environment === EnvType.PEACOCK || 
			this.props.environment === EnvType.APPLETV ) {
			this.props.eventHandler({ 
				data: { 
					event_type: "billboard_click", 
					asset_name: this.props.video.name, 
					asset_id: this.props.video._id,
					row_name: this.props.label.split("_")[0], 
					row_id: this.props.label.split("_")[1],
					page_location: `home_page`,
					time: Date.now() 
				}
			});
		} else {
			this.props.eventHandler({
				data: {
					event_type: "asset_fullscreen_playback_from_billboard",
					type: "billboard",
					action: "asset_fullscreen_playback_from_billboard",
					asset_id: videoItem._id.valueOf(),
					time: Date.now()
				}
			});
		}
	}

	upVolume () {
		/* Google analytics event - Global Mute Status */
		let svodStatus = new SVODStatus(SVODStatusEvent.SVODSESSION_MUTE, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		svodStatus.state = this.state;
		svodStatus.label = 'FALSE';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

		// update the button so that it is based off of the props (so there doesn't need to be three functions (get rid of setState));
		this.props.toggleVolume(true);
		this.videoElement.updateVideoPlayer("volume", true);
	}

	downVolume () {
		/* Google analytics event - Global Mute Status */
		let svodStatus = new SVODStatus(SVODStatusEvent.SVODSESSION_MUTE, '', '', false, false, true, false);
		svodStatus.gaTracker = this.props.tracker;
		svodStatus.state = this.state;
		svodStatus.label = 'TRUE';
		this.props.globalAnalyticsAdapter.reportAnalyticsEvent(svodStatus);

		this.props.toggleVolume(false);
		this.videoElement.updateVideoPlayer("volume", false);
	}

	updateWatchlist() {
		if (this.props.watchlist.includes(this.video._id.valueOf())) {
			this.props.eventHandler({ data: { event_type: "watchlist", action: "removed_from_watchlist", type: "tile", asset_id: this.video._id.valueOf(), time: Date.now() } });

			let newWatchlist = this.props.watchlist.filter((value) => { return value !== this.video._id.valueOf(); });
			this.props.updateWatchlist(newWatchlist);
			if (this.props.watchlist_video) {
				this.setState({ watchlistRemoved: true });
			}
		} else {
			this.props.eventHandler({ data: { event_type: "watchlist", action: "added_to_watchlist", type: "tile", asset_id: this.video._id.valueOf(), time: Date.now() } });
			let newWatchlist = [...this.props.watchlist, this.video._id.valueOf()];
			this.props.updateWatchlist(newWatchlist);
		}
	}

	videoEnded () {
		this.setState({active: false});
	}
	
	restartVideo () {
		this.props.newActiveVideo("billboard");
		this.props.removeDropdown();
		this.setState({active: true});
	}

	selectAsset(asset) {
		this.props.setSelectedAsset(asset);
		this.props.setSelectedAssetRow(this.props.label);
	}

	render() {
		const { isDynamicBillboard } = this.props;
		let videoItem = this.video;

		let mpaa = (videoItem.content.mpaa !== undefined) ? (
			<span className="index-rating">{videoItem.content.mpaa.label}</span>
		) : (
			<span></span>
		);

		let volumeButton = (this.state.active && this.props.activeVideo === "billboard" && this.props.activeBillboard) ? (
			(this.props.volume.volume) ? (
				<button className="on-volume" id="splash-vol" onClick={this.downVolume}><i className="fas fa-volume-up"></i></button>
			) : (
				<button className="on-volume" id="splash-vol" onClick={this.upVolume}><i className="fas fa-volume-off"></i></button>
			)
		) : (
			<button className="on-volume" id="splash-vol" onClick={this.restartVideo}><i className="fas fa-sync-alt"></i></button>
		);

		let watchlistButton = (this.props.watchlist.includes(this.video._id.valueOf())) ? (
			<button onClick={this.updateWatchlist} className="billboard-watchlist" id={`watchlist-${this.video._id.valueOf()}`}><i className="fas fa-check" id="amazon-font-img"></i>{this.props.intl.formatMessage(svodMessages.watchlist)}</button>
		) : (
			<button onClick={this.updateWatchlist} className="billboard-watchlist" id={`watchlist-${this.video._id.valueOf()}`}><i className="fas fa-plus" id="amazon-font-img"></i>{this.props.intl.formatMessage(svodMessages.watchlist)}</button>
		);
       
		let title = (this.video.images.title_image === undefined) ? (
			<p className="title">{videoItem.content.title}</p>
		) : (
			<p className="title">
				<img src={videoItem.images.title_image} alt=""/>
			</p>
		);
		
		let content = (this.state.active && !this.props.isSurveyActive && this.props.activeVideo === "billboard" && this.props.activeBillboard) ? (
			<VideoPlayer location="BILLBOARDVIDEO" id="rpo-vid" videoEnded={this.videoEnded} onRef={ref => this.videoElement = ref} video={videoItem} watchpage={false} {...this.props}/>
		) : (
			<img className="splash-img" id={`${this.props.label}-${videoItem._id.valueOf()}-img`} src={videoItem.images.background} alt={videoItem.images.background}/>
		);
		
		let renderBillboard = (environment) => {
			switch (environment) {
				case (EnvType.AMAZON): {
					return (
						<div className="rpo-div videoItem-billboard" onClick={() => this.selectAsset(videoItem)}>
				
							<div className="rpo-text">
								{title}
								<p className="summary">{videoItem.content.logline}</p>
								<div id="splash-buttons">
									<Link to="/study/watch" onClick={this.triggerReport}>
										<button id="splash-play" ><i className="fas fa-play fa-fw" id="amazon-font-img"/> {this.props.intl.formatMessage(svodMessages.watch_now)}</button>
									</Link>
									{watchlistButton}
									<button id="splash-info" onClick={this.handleOpen}>{this.props.intl.formatMessage(svodMessages.details)}</button>
								</div>
							</div>
			
							<div className="rpo-vid-div">
								{content}	
								{volumeButton}
							</div>
			
						</div>
					);
				}
				case (EnvType.PEACOCK): {
					return (
						<div className="rpo-div videoItem-billboard" onClick={() => this.selectAsset(videoItem)}>	
							<Link to="/study/showpage" onClick={this.triggerReport}>
								<img className="rpo-pic" id={`${this.props.label}-${videoItem._id.valueOf()}-img`} src={videoItem.images.thumbnail} />
							</Link>
						</div>
					);
				}
				case (EnvType.APPLETV): {
					let thumbnailLink = "/study/showpage";
					if (videoItem.transactional) {
						thumbnailLink = "/study/transaction";
					}
					if (isDynamicBillboard) {
						return (
							<div className={`rpo-div videoItem-billboard dynamic-billboard`} onClick={() => this.selectAsset(videoItem)}>
								<Link className='cursor-default' to={thumbnailLink} onClick={this.triggerReport}>
									<img className={`rpo-pic`}
										id={`${this.props.label}-${videoItem._id.valueOf()}-img`}
										src={videoItem.images.billboard_wide ? videoItem.images.billboard_wide : videoItem.images.thumbnail}
									/>
								</Link>
							</div>
						);
					}
					else {
						return (
							<div className={`rpo-div videoItem-billboard`} onClick={() => this.selectAsset(videoItem)}>	
								<Link className='cursor-default' to={thumbnailLink} onClick={this.triggerReport}>
									<img className={`rpo-pic standard-billboard`}
										id={`${this.props.label}-${videoItem._id.valueOf()}-img`}
										src={videoItem.images.billboard_wide || videoItem.images.thumbnail}
									/>
								</Link>
							</div>
						);
					}
				}
				default: { // netflix
					if (!this.props.dropdown.video) {
						return (
							<div className="rpo-div" onClick={() => this.selectAsset(videoItem)}>
								<div className="rpo-text">
									{title}
									<p className="summary">{videoItem.content.logline}</p>
									<div id="splash-buttons">
										<Link to="/study/watch" onClick={this.triggerReport}>
											<button id="splash-info"><i className="fas fa-play fa-fw" /> {this.props.intl.formatMessage(svodMessages.play)}</button>
										</Link>

										<button id="splash-info" onClick={this.handleOpen}><i className="fas fa-info-circle" /> {this.props.intl.formatMessage(svodMessages.more_info)}</button>
									</div>
								</div>

								<div className="rpo-vid-div">
									{content}
									<span className="billboard-right">
										{volumeButton}
										{mpaa}
									</span>
								</div>

								<div id="billboard-cover"></div>
							</div>
						);
					}
					else if (this.props.dropdown.label === "Splash") {
						return (
							<div className="rpo-div" onClick={() => this.selectAsset(videoItem)}>
								<div className="rpo-text">
									{title}
									<p className="summary">{videoItem.content.logline}</p>
									<div id="splash-buttons">
										<Link to="/study/watch" onClick={this.triggerReport}>
											<button id="splash-info"><i className="fas fa-play fa-fw" /> {this.props.intl.formatMessage(svodMessages.play)}</button>
										</Link>
										<button id="splash-info" onClick={this.handleOpen}><i className="fas fa-info-circle" /> {this.props.intl.formatMessage(svodMessages.more_info)}</button>
									</div>
								</div>

								<div className="rpo-vid-div">
									<img className="splash-img" id={`${this.props.label}-${videoItem._id.valueOf()}-img`} src={videoItem.images.background} alt={videoItem.images.thumbnail} />

									<span className="billboard-right">
										{volumeButton}
										{mpaa}
									</span>
								</div>

								<div id="billboard-cover"></div>
							</div>
						);
					}
				}
			}
		};
			
		
		return (
			<div id={this.props.label} >
				{renderBillboard(this.props.environment)}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	dropdown: state.SVOD.dropdown,
	activeVideo: state.SVOD.activeVideo,
	volume: state.SVOD.volume,
	watchlist: state.SVOD.watchlist,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
	isSurveyActive: state.SVOD.isSurveyActive,
});


const mapDispatchToProps = (dispatch) => ({
	displayDropdown: (payload) => dispatch(displayDropdown(payload)),
	removeDropdown: () => dispatch(removeDropdown()),
	newActiveVideo: (payload) => dispatch(newActiveVideo(payload)),
	updateWatchlist: (newWatchlist) => dispatch(updateWatchlist(newWatchlist)),
	toggleVolume: (volume) => dispatch(toggleVolume(volume)),
	setSelectedAsset: (asset) => dispatch(setSelectedAsset(asset)),	
	setSelectedAssetRow: (label) => dispatch(setSelectedAssetRow(label)),	
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(BillboardItem));


// WEBPACK FOOTER //
// ./src/components/svod/billboard-item.jsx